module.exports = __webpack_public_path__ + "img/geschmiedetesgelaender.4448a63d.webp";